import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { RetirementReason } from '/src/lib/models';

export type TListRetirementReasonsRequest = {
  visible_to_equipment?: boolean;
  visible_to_facilities?: boolean;
};

export class RetirementReasonService {
  /**
   * List Retirement Reasons
   * @returns RetirementReason[]
   * @throws ApiError
   */
  public static list(req?: TListRetirementReasonsRequest): CancelablePromise<RetirementReason[]> {
    return __request(OpenAPI, { method: 'GET', url: '/retirementReasons', query: req });
  }
}
